// Module
var code = "<div id=\"preloader\" class=\"col-md-10 col-md-offset-1\">\r\n\r\n    <br>\r\n\r\n    <h2 data-bind=\"restext: 'PageNotAvailableTitle'\"></h2>\r\n    <p data-bind=\"restext: 'PageNotAvailableText'\"></p>\r\n\r\n    <p>\r\n        <a data-bind=\"restext: 'ReturnToRequestList'\" href=\"#requests\"></a>\r\n    </p>\r\n</div>\r\n";
// Exports
export default code;